var exports = {
  "kL": "xdbfd91f1--d89ffb--container",
  "wx": "xdbfd91f1--d89ffb--header",
  "Qs": "xdbfd91f1--d89ffb--content",
  "vR": "xdbfd91f1--d89ffb--tabs",
  "Mf": "xdbfd91f1--d89ffb--tab",
  "qw": "xdbfd91f1--d89ffb--tab--active",
  "cM": "xdbfd91f1--d89ffb--tab-icon",
  "hl": "xdbfd91f1--d89ffb--address",
  "Cp": "xdbfd91f1--d89ffb--address-link",
  "hX": "xdbfd91f1--d89ffb--commute",
  "Rs": "xdbfd91f1--d89ffb--commute-distance",
  "NJ": "xdbfd91f1--d89ffb--commute-icon",
  "FI": "xdbfd91f1--d89ffb--general-plan",
};

module.exports = exports;
